export default "__VITE_ASSET__CWejL9Uv__"